import { render, staticRenderFns } from "./remove-article-watch.vue?vue&type=template&id=3207bd18&"
import script from "./remove-article-watch.vue?vue&type=script&lang=js&"
export * from "./remove-article-watch.vue?vue&type=script&lang=js&"
import style0 from "./remove-article-watch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports